import {
	Backdrop,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Theme,
	createStyles,
	makeStyles
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { api } from "../../../../../../utils/api";
import { ThreeCircles } from "react-loader-spinner";

const backdropStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: "#fff",
			position: "absolute"
		}
	})
);

const DeleteDialog = ({ open, handleClose, documentObectId, setDocumentList, setAllDocumentList }: any) => {
	const backdropClasses = backdropStyles();
	const [loading, setLoading] = useState<boolean>(false);
	const handleDeleteDocument = useCallback(async () => {
		try {
			setLoading(true);
			const docId = await api.documentSharing.deleteAdminDocument(documentObectId);
			// eslint-disable-next-line prettier/prettier
			setDocumentList((prevList: any[]) => prevList.filter(doc => doc._id !== docId));
			// eslint-disable-next-line prettier/prettier
			setAllDocumentList((prevList: any[]) => prevList.filter(doc => doc._id !== docId));
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
			handleClose();
		}
	}, [documentObectId, handleClose, setAllDocumentList, setDocumentList]);
	const handleDeleteButtonClick = () => {
		handleDeleteDocument();
	};
	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"Are You Sure to Delete this document?"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						After Deleting this file,it will be removed permanently
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						variant="outlined"
						onClick={handleDeleteButtonClick}
						style={{ borderColor: "#9400FF", color: "#9400FF" }}
					>
						Yes,Delete
					</Button>
					<Button
						variant="contained"
						onClick={handleClose}
						color="primary"
						style={{ backgroundColor: "indigo" }}
						autoFocus
					>
						No
					</Button>
				</DialogActions>
			</Dialog>
			<Backdrop className={backdropClasses.backdrop} open={loading}>
				<ThreeCircles
					height="100"
					width="100"
					color="#4fa94d"
					wrapperStyle={{}}
					wrapperClass=""
					visible={true}
					ariaLabel="three-circles-rotating"
					outerCircleColor=""
					innerCircleColor=""
					middleCircleColor=""
				/>
			</Backdrop>
		</div>
	);
};

export default DeleteDialog;
